// test2897
(2897 && 0);
